<template>
  <div
    class="container-fluid brdcrm-wrap"
    v-if="breadcrumbs"
    :key="'breadcrumb_' + $route.path"
  >
    <div class="row text-white mt-5 mt-md-0">
      <div
        class="col-lg-2 col-md-3 col-sm-4 col-12 pt-3 pb-3 pl-5 bg-primary mt-3 mt-md-0"
      >
        {{ breadcrumbs.title }}
      </div>
      <div class="col-lg-10 col-md-9 col-sm-8 col-12 pt-3 pb-3 bg-dark">
    <ul class="list-unstyled m-0 brdcrm-ul">
          <li class="d-inline"><a href="/" class="text-white">Home</a></li>
          <li
            class="d-inline"
            v-for="(crumb, index) in breadcrumbs.links"
            :key="'breadcrumb_' + index"
          >
            >
            <a :href="crumb.href" class="text-white">
              {{ " " + crumb.title + " " }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "breadcrumbs",
  computed: {
    breadcrumbs() {
      return this.$store.state.breadcrumbs;
    },
  },
};
</script>
